import React from 'react'
import { getStatusIcon } from '../../utils';
import NodeContent from './NodeContent';
import { Handle, NodeProps, Position } from 'reactflow';
import { WorkflowStatusModel } from '../../models/Workflow';

type ServiceNodeData = {
  mode: 'SOURCE' | 'PROCESSOR' | 'SINK';
  text: string;
  statusModel: WorkflowStatusModel;
  label: string;
}

export default function StreamServiceNode({ data, isConnectable }: NodeProps<ServiceNodeData>) {
  const hasInputPort = data.mode === 'SINK' || data.mode === 'PROCESSOR';
  const hasOutputPort = data.mode === 'SOURCE' || data.mode === 'PROCESSOR';
  const mode = data.mode.toLowerCase();

  return (
    <div className={`service-node ${mode}`}>
      {data.statusModel && <div className="service-status">{getStatusIcon(data.statusModel.status)}</div>}

      {hasInputPort && (
        <div className="input-ports">
          <Handle
            className={`custom-handle service-handle ${mode}-service-handle`}
            key="input-port"
            type="target"
            position={Position.Top}
            id="input-port"
            isConnectable={isConnectable}
          />
        </div>
      )}

      <NodeContent title={data.label} type={mode} />

      {hasOutputPort && (
        <div className="output-ports">
          <Handle
            type="source"
            key="output-port"
            className={`custom-handle service-handle ${mode}-service-handle`}
            position={Position.Bottom}
            id="output-port"
            isConnectable={isConnectable}
          />
        </div>
      )}
    </div>
  );
}
